'use client'

import { EmptyMessage, GrandSection } from 'ui'
import type { FC } from 'react'
import { PiLinkBreak } from 'react-icons/pi'

interface NotFoundStdPageProps {
  text: string
}

const NotFoundStdPage: FC<NotFoundStdPageProps> = ({ text }) => {
  return (
    <GrandSection
      alignItems="center"
      display="flex"
      justifyContent="center"
      minH="50vh"
      sectionId="not-found"
    >
      {/* React 19 + Chakra v2: `<Icon as={PiLinkBreak}>` crashes during static
          prerender with "$$typeof undefined" — same root cause as our GrandLink
          fix. Rendering the react-icon directly skips Chakra's `as` resolution. */}
      <PiLinkBreak size={50} style={{ alignSelf: 'center' }} />
      <EmptyMessage fontSize="2xl" {...{ text }} />
    </GrandSection>
  )
}

export default NotFoundStdPage
